export enum JourneyStage {
  // Common Stages
  EXPLORING = "EXPLORING",
  OTHER = "OTHER",

  // Adoption Stages
  CHOOSING_AGENCY_ATTORNEY = "CHOOSING_AGENCY_ATTORNEY",
  WORKING_WITH_AGENCY_ATTORNEY = "WORKING_WITH_AGENCY_ATTORNEY",
  FINAL_STAGES = "FINAL_STAGES",

  // Gestational Stages
  CHOOSING_AGENCY_CLINIC_ATTORNEY = "CHOOSING_AGENCY_CLINIC_ATTORNEY",
  WORKING_WITH_AGENCY_CLINIC_ATTORNEY = "WORKING_WITH_AGENCY_CLINIC_ATTORNEY",
  GESTATIONAL_PREGNANT = "GESTATIONAL_PREGNANT",

  // Preservation Stages
  PRESERVATION_READY = "PRESERVATION_READY",
  PRESERVATION_STARTED = "PRESERVATION_STARTED",
  PRESERVATION_RECENTLY_RECEIVED = "PRESERVATION_RECENTLY_RECEIVED",

  // Assisted Reproduction Stages
  MIGHT_WANT_IUI_IVF = "MIGHT_WANT_IUI_IVF",
  GETTING_READY_START_IUI = "GETTING_READY_START_IUI",
  GETTING_READY_START_IVF = "GETTING_READY_START_IVF",
  ALREADY_STARTED_IUI_CYCLE = "ALREADY_STARTED_IUI_CYCLE",
  ALREADY_STARTED_IVF_CYCLE = "ALREADY_STARTED_IVF_CYCLE",
  RECENTLY_COMPLETED_IUI_CYCLE = "RECENTLY_COMPLETED_IUI_CYCLE",
  RECENTLY_COMPLETED_IVF_CYCLE = "RECENTLY_COMPLETED_IVF_CYCLE",

  // Try Pregnant Stages
  HAVE_NOT_STARTED = "HAVE_NOT_STARTED",
  TRY_PREGNANT_LESS_THAN_SIX_MONTHS = "TRY_PREGNANT_LESS_THAN_SIX_MONTHS",
  TRY_PREGNANT_SIX_TO_TWELVE_MONTHS = "TRY_PREGNANT_SIX_TO_TWELVE_MONTHS",
  TRY_PREGNANT_OVER_ONE_YEAR = "TRY_PREGNANT_OVER_ONE_YEAR",

  // Pregnancy Stages
  PREGNANT_FIRST = "PREGNANT_FIRST",
  PREGNANT_SECOND = "PREGNANT_SECOND",
  PREGNANT_THIRD = "PREGNANT_THIRD",
  POSTPARTUM = "POSTPARTUM",

  // Exploring Stages
  NOT_SURE_PARENT = "NOT_SURE_PARENT",
  LEARNING_FERTILITY = "LEARNING_FERTILITY",
  EXPLORING_NO_PATH = "EXPLORING_NO_PATH",
  EXPLORING_MULTIPLE_PATHS = "EXPLORING_MULTIPLE_PATHS",
  EXPLORING_NEW_OPTIONS = "EXPLORING_NEW_OPTIONS",

  // Menopause Stages
  START_OF_PERI_MENOPAUSE = "START_OF_PERI_MENOPAUSE",
  MENOPAUSE_SYMPTOMS_WITH_MENSTRUAL_CYCLES = "MENOPAUSE_SYMPTOMS_WITH_MENSTRUAL_CYCLES",
  NO_MENSTRUAL_CYCLES = "NO_MENSTRUAL_CYCLES",

  // Low Testosterone Stages
  EXPERIENCING_LOW_T_SYMPTOMS = "EXPERIENCING_LOW_T_SYMPTOMS",
  DIAGNOSED_LOW_T = "DIAGNOSED_LOW_T",

  // Gender Affirming Care Stages
  HORMONE_THERAPY_INTEREST = "HORMONE_THERAPY_INTEREST",
  NON_HORMONAL_SUPPORT_INTEREST = "NON_HORMONAL_SUPPORT_INTEREST",
  ON_HORMONES = "ON_HORMONES",
  GOING_OFF_HORMONES = "GOING_OFF_HORMONES",
  OTHER_WITH_USER_INPUT = "OTHER_WITH_USER_INPUT",

  // Parenting Stages
  CHILD_LESS_THAN_YEAR = "CHILD_LESS_THAN_YEAR",
  CHILD_ONE_TO_TWO_YEARS = "CHILD_ONE_TO_TWO_YEARS",
  CHILD_THREE_TO_FIVE_YEARS = "CHILD_THREE_TO_FIVE_YEARS",
  CHILD_SIX_TO_EIGHT_YEARS = "CHILD_SIX_TO_EIGHT_YEARS",
  CHILD_NINE_TO_TWELVE_YEARS = "CHILD_NINE_TO_TWELVE_YEARS"
}

const NCQA_QUALIFIED_JOURNEY_STAGES: ReadonlySet<string> = new Set([
  JourneyStage.GETTING_READY_START_IVF,
  JourneyStage.ALREADY_STARTED_IVF_CYCLE
])

export function isNcqaQualifiedJourneyStage(stage: string): boolean {
  return NCQA_QUALIFIED_JOURNEY_STAGES.has(stage)
}
